/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { Typography } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormHelperText from '@mui/material/FormHelperText';
import makeStyles from '@mui/styles/makeStyles';
import { useDeviceDetect } from 'hooks';

import Styles from './styles';

const useStyles = makeStyles(Styles);

function CustomRadioGroup({ options, label, error, helperText, value, column, ...props }) {
  const classes = useStyles();
  const { isDesktop } = useDeviceDetect();
  return (
    <FormControl className={classes.fieldSet} component="fieldset" error={error}>
      <FormLabel component="legend">{label}</FormLabel>
      <RadioGroup row={isDesktop && !column} {...props} value={value}>
        {options.map((option) => {
          const { value: optionValue, label: optionLabel } = option;
          return (
            <FormControlLabel
              className={classes.radioBtn}
              key={optionValue}
              value={optionValue}
              control={<Radio color="primary" data-testid="radio" />}
              label={
                <Typography component="span" variant="body1" classes={{ root: value === optionValue ? classes.activeRadioLabel : classes.radioLabel }}>
                  {optionLabel}
                </Typography>
              }
            />
          );
        })}
      </RadioGroup>
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
}

CustomRadioGroup.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  options: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.object), PropTypes.arrayOf(PropTypes.string)]),
  value: PropTypes.objectOf(PropTypes.any),
  column: PropTypes.bool,
  ...RadioGroup.propTypes,
};

CustomRadioGroup.defaultProps = {
  options: [],
  value: {},
  column: false,
};

export default CustomRadioGroup;
